import { useRef } from 'react';
import { useStatsigClient } from '@statsig/react-bindings';

export type ReadyGate = 'pending' | 'on' | 'off';

/**
 * A gate checked once Statsig is ready ('pending' until then), so the exposure logs the real
 * value, not the default. Fixed for the mount; use `useGateValue` for gates that follow live updates.
 */
export function useReadyGate(gateName: string): ReadyGate {
  const { isLoading, checkGate } = useStatsigClient();
  const decided = useRef<ReadyGate>('pending');

  if (decided.current === 'pending' && !isLoading) {
    decided.current = checkGate(gateName) ? 'on' : 'off';
  }
  return decided.current;
}
